<div class="flex flex-column">
  <div class="inline-flex mt-2">
    <span class="col-fixed p-0 mr-2" [style.width.px]="20" *ngIf="history.historyId == null">
      <p-checkbox [name]="history.id! + '--checkbox'" [(ngModel)]="history.filled"
        (ngModelChange)="handleChange(true)" [binary]="true"></p-checkbox>
    </span>

    <label class="col p-0 mb-0 font-semibold" [style.marginTop]="'2px!important'" [for]="history.id"
      (click)="handleLabelClick()">
      {{history.name}}
    </label>
  </div>

  <div class="mt-2" *ngIf="history.filled">
    <textarea pInputTextarea [name]="history.id!" [(ngModel)]="history.details" (ngModelChange)="handleChange()"
      [rows]="2" validation [disabled]="!history.filled" [required]="history.filled" class="uppercase no-margin">
    </textarea>
  </div>
</div>